import RelatorioVendaService from "@/services/relatorio/RelatorioVendaService";
import VendaService from "@/services/VendaService";
export const actions = {
  gerarRelatorioComissao({ commit }, data) {
    commit("setOverlay", true);
    RelatorioVendaService.comissao(data)
      .then((res) => {
        commit("setOverlay", false);
        commit("setModalPrint", res.data.pdf_link);
      })
      .catch((e) => {
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao gerar relatório.");
      });
  },
  gerarRelatorioVenda({ commit }, data) {
    commit("setOverlay", true);
    RelatorioVendaService.vendasPorPeriodo({
      periodo_inicial: data.periodo_inicial,
      periodo_final: data.periodo_final,
      formaPagamentoId: data.formaPagamentoId,
      content: "pdf",
    })
      .then((res) => {
        commit("setOverlay", false);
        commit("setModalPrint", res.data.pdf_link);
      })
      .catch((e) => {
        console.log(e);
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao gerar relatório.");
      });
  },
  gerarRelatorioProdutoVendido({ commit }, data) {
    commit("setOverlay", true);
    RelatorioVendaService.produtosVendidos(data)
      .then((res) => {
        commit("setModalPrint", res.data.pdf_link);
        commit("setOverlay", false);
      })
      .catch((e) => {
        console.log(e);
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao gerar relatório.");
      });
  },
};

export default {};
